var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.visible)?_c('div',{staticClass:"animate-review-prompt",attrs:{"id":"reviewPrompt"}},[_c('el-button',{staticClass:"pulse-button",attrs:{"round":"","size":"small","type":"primary"},on:{"click":function($event){return _vm.goToReviews()}}},[_vm._v("Get your song reviewed")])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }